import type { TableRequestBody, TableRequestColumns } from '@ipfabric/utils';
import type { CloudNatGatewayDetailData } from './CloudNatGatewayDetailContent';

interface RequestPayload {
  gatewayId: string;
  snapshotId: string;
}

interface CloudNatGatewaysRequest {
  url: string;
  method: string;
  data: TableRequestBody<CloudNatGatewayDetailData>;
}

export const getCloudNatGatewayDetailRequestPayload = ({
  gatewayId,
  snapshotId,
}: RequestPayload): CloudNatGatewaysRequest => {
  const columns: TableRequestColumns<CloudNatGatewayDetailData> = [
    'cloudProvider',
    'gatewayId',
    'name',
    'vpcId',
    'region',
    'availabilityMode',
    'connectivityType',
    'sku',
    'awsArn',
    'availabilityZoneList',
    'routeTableId',
    'cloudRouterId',
    'publicIpv4List',
    'publicIpv6List',
  ];
  return {
    url: '/tables/cloud/nat-gateways/inventory',
    method: 'POST',
    data: {
      columns,
      filters: { gatewayId: ['eq', gatewayId] },
      snapshot: snapshotId,
    },
  };
};
